import React from 'react';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	state: 'state',
	creditedAt: 'creditedAt',
	creditedBy: 'creditedBy',
	uploadedAt: 'uploadedAt',
	uploadedBy: 'uploadedBy',
	csvName: 'csvName',
	csvUrl: 'csvUrl',
	description: 'description'
};

export const columnConfigs = [
	StringColumn({
		title: 'CSV Name',
		mapDataToValue: (data: any) => data[COL_NAMES.csvName]
	}),
	StringColumn({
		title: 'Description',
		minWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.description]
	}),
	StringColumn({
		title: 'State',
		mapDataToValue: (data: any) => data[COL_NAMES.state]
	}),
	StringColumn({
		title: 'Credited By',
		minWidth: 150,
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.creditedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Credited At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.creditedAt
	}),
	StringColumn({
		title: 'Uploaded By',
		mapDataToValue: (data: any) => data[COL_NAMES.uploadedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Uploaded At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.uploadedAt
	}),
	CustomColumn({
		title: 'CSV Url',
		mapDataToValue: (data: any) => {
			return {
				csvUrl: data[COL_NAMES.csvUrl]
			};
		},
		renderCell: (params: any) => {
			const { value } = params;
			return <a href={value?.csvUrl}>{value?.csvUrl}</a>;
		}
	})
];
